import Service from "./Service"
import { api } from "./config"
import qs from "qs"

const urlParamsHandler = (url, params) => { return String(url).toLowerCase() + "?" + qs.stringify({ ...params }, { arrayFormat: "repeat" }) }

const Ticket = {
    getMetadata: (source) => { return Service.get(urlParamsHandler("/tickets/metadata", { source: source })) },
    searchsite: (sitename) => { return Service.get(urlParamsHandler("/tickets/searchsite", { sitename: sitename })) },
    searchfalocation: (falocation) => { return Service.get(urlParamsHandler("/tickets/searchfalocation", { falocation: falocation })) },
    onSubmit: (form) => { return Service.post("/tickets/createticket", form) },
    executeAction: (payload) => { return Service.post("/tickets/executeaction", payload) },
    closeTicket: (id) => { return Service.get(urlParamsHandler("/tickets/closeticket", { id: id })) },
    getDetails: (id) => { return Service.get(urlParamsHandler("/tickets/ticketdetails", { id: id })) },
}

const TicketSearch = {
    getTickets: (paging, filters) => { return Service.post(urlParamsHandler("/tickets/gettickets", paging), filters) }
}

const Reports = {
    getDirectoryStructure: (payload) => { return Service.get(urlParamsHandler("/tickets/getsirectorystructure", payload)) },
    getFileContents: (path, type) => {
        path = String(path)[0] === "\\" || String(path)[0] === "/" ? String(path).substring(1, String(path).length) : String(path)
        if (["log", "txt"].includes(type)) {
            return Service.get(urlParamsHandler("/tickets/getfilecontents", { path: path }))
        } else if (["jpg", "png", "html"].includes(type)) {
            return Service.get(urlParamsHandler("/tickets/getfilecontents", { path: path }))
        } else if (["pdf"].includes(type)) {
            return Service.get(urlParamsHandler("/tickets/getfilecontents", { path: path }) + "#toolbar=0&view=fitH")
        } else {
            return null
        }
    },
    getReport: (payload) => { return Service.get(urlParamsHandler("/tickets/getreport", payload)) },
    getHardwareReport: (sitename) => { return Service.get(urlParamsHandler("/tickets/hardwarereport", { sitename: sitename })) }
}

const RSSI = {
    getMetadata: () => { return Service.get(urlParamsHandler("/rssi/tickets/getmetadata")) },
    getTickets: (paging, filters) => { return Service.post(urlParamsHandler("/rssi/tickets/gettickets", paging), filters) },
    getTicketHistory: (quantumId, workorder) => { return Service.get(urlParamsHandler("/rssi/tickets/gettickethistory", { quantumId, workorder })) },
    onAction: (payload) => { return Service.post(urlParamsHandler("/rssi/tickets/updateticket"), payload, { headers: { "Content-type": "multipart/form-data" } }) },
    showFile: (payload) => { return Service.get(urlParamsHandler("rssi/tickets/showfile", payload), { responseType: "arraybuffer" }) },
    download: (payload) => { return Service.get(urlParamsHandler("/rssi/tickets/downloadfile", payload), { responseType: "arraybuffer" }) },
    getMyUsers: (payload) => { return Service.post(urlParamsHandler("/rssi/tickets/getmyusers"), payload) },
    markChecklistItem: (payload) => { return Service.post(urlParamsHandler("/rssi/tickets/markChecklistItem"), payload) },
    deeplink: (payload) => { return Service.get(urlParamsHandler("/rssi/deeplink/getdetails", payload)) },
}

const DIYServices = {
    Ticket: Ticket,
    TicketSearch: TicketSearch,
    Reports: Reports,
    RSSI: RSSI
}

export default DIYServices
